export default {
  'dashboard-analysis.analysis.test': 'Gongzhuan No.{no} shop',
  'dashboard-analysis.analysis.introduce': 'Introduce',
  'dashboard-analysis.analysis.total-sales': 'Total Sales',
  'dashboard-analysis.analysis.day-sales': 'Daily Sales',
  'dashboard-analysis.analysis.visits': 'Visits',
  'dashboard-analysis.analysis.visits-trend': 'Visits Trend',
  'dashboard-analysis.analysis.visits-ranking': 'Visits Ranking',
  'dashboard-analysis.analysis.day-visits': 'Daily Visits',
  'dashboard-analysis.analysis.week': 'WoW Change',
  'dashboard-analysis.analysis.day': 'DoD Change',
  'dashboard-analysis.analysis.payments': 'Payments',
  'dashboard-analysis.analysis.conversion-rate': 'Conversion Rate',
  'dashboard-analysis.analysis.operational-effect': 'Operational Effect',
  'dashboard-analysis.analysis.sales-trend': 'Stores Sales Trend',
  'dashboard-analysis.analysis.sales-ranking': 'Sales Ranking',
  'dashboard-analysis.analysis.all-year': 'All Year',
  'dashboard-analysis.analysis.all-month': 'All Month',
  'dashboard-analysis.analysis.all-week': 'All Week',
  'dashboard-analysis.analysis.all-day': 'All day',
  'dashboard-analysis.analysis.search-users': 'Search Users',
  'dashboard-analysis.analysis.per-capita-search': 'Per Capita Search',
  'dashboard-analysis.analysis.online-top-search': 'Online Top Search',
  'dashboard-analysis.analysis.the-proportion-of-sales': 'The Proportion Of Sales',
  'dashboard-analysis.channel.all': 'ALL',
  'dashboard-analysis.channel.online': 'Online',
  'dashboard-analysis.channel.stores': 'Stores',
  'dashboard-analysis.analysis.sales': 'Sales',
  'dashboard-analysis.analysis.traffic': 'Traffic',
  'dashboard-analysis.table.rank': 'Rank',
  'dashboard-analysis.table.search-keyword': 'Keyword',
  'dashboard-analysis.table.users': 'Users',
  'dashboard-analysis.table.weekly-range': 'Weekly Range',
};
